import React, { useEffect, useState } from "react";

import { PRIORITY, PRIORITYIN, PRIORITYACTIN, PRIORITYACTOUT, PRIORITYACT } from '../../utils/priority';

import '../ReqList/ReqList.css';
import './PrioritySelect.css';

//document puede ser un activo, un procedimiento, un requerimiento o cualquier otro comprobante.
const PrioritySelect = ({document, handleChange, documentType = 'activo'}) => {

const [priority,setPriority] = useState({0:'',1:'',2:''})
const [priorityIn,setPriorityIn] = useState({0:'',1:'',2:''})
const [displayOptions,setDisplayOptions] = useState(false);

const handleSelecPriority = (indexPriority) => {
    handleChange(indexPriority)
    setDisplayOptions(false);
}

useEffect(()=>{
    if(documentType == 'activo') {
        setPriority(PRIORITYACT);
        setPriorityIn(PRIORITYACTIN);
    }
},[])

return <div id="prioritySelectContainer" className='container-prioritys-gral'>
    <div id="prioritySelect" className={document.priority == 2 ? 'r-list-item-header-priority-urgente  margin-right-r' : document.priority == 1 ? 'r-list-item-header-priority-alta  margin-right-r' : 'r-list-item-header-priority-media  margin-right-r'} onClick={() => setDisplayOptions(!displayOptions)}>
        {priority[document.priority ? document.priority : 0]}
    </div>
    {displayOptions &&
        <div className='options-container-fr  margin-right-r opciones'>
            <div className='options-container-fr-back'>
                {priority.map((prior) => {
                    return (
                        <div key={prior} className={priorityIn[prior] == 2 ? 'r-list-item-header-priority-urgente' : priorityIn[prior] == 1 ? 'r-list-item-header-priority-alta' : 'r-list-item-header-priority-media'} value={prior} onClick={() => handleSelecPriority(priorityIn[prior])}>{prior}</div>
                    );
                })}
            </div>
        </div>
    }
</div>
}

export default PrioritySelect;